<popup-header [titleIcon]="data.titleIcon"
              [icon]="icon"
              (clickAction)="cancelAction()"
              [text]="data.title">
</popup-header>

<div class="message-content">
    {{ data.message }}
    <div *ngIf="messages">
        <ul>
            <li *ngFor="let message of messages">{{message}}</li>
        </ul>
    </div>
</div>

<popup-button-container>
    <cas-button [color]="null"
                [hidden]="!showCancelBtn"
                [btnText]="cancelBtnText"
                (clickAction)="cancelAction()"></cas-button>

    <cas-button btnClass="md-raised md-accent {{ isWarning ? 'md-warn' : '' }}"
                (clickAction)="confirmAction()"
                [btnText]="confirmBtnText">
    </cas-button>
</popup-button-container>